module.exports = __webpack_public_path__ + "static/img/wq-3.dfed55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wq-3.png
// module id = BcPr
// module chunks = 0